// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Eo4j","selected":"Chip_selected__112r6"};